import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RootService {

  activitiesEndpoint = 'http://isla.rogiroaceros.com:9980/cgi-bin/wspd_cgi.sh/WService=rogiro/ctacte.r';
  balanceEndpoint = 'http://isla.rogiroaceros.com:9980/cgi-bin/wspd_cgi.sh/WService=rogiro/ctasaldos.r';
  changePasswordEndpoint = 'http://isla.rogiroaceros.com:9980/cgi-bin/wspd_cgi.sh/WService=rogiro/changePassword.r';
  getItemEndpoint = 'http://isla.rogiroaceros.com:9980/cgi-bin/wspd_cgi.sh/WService=rogiro/articulos.r';
  pendingEndpoint = 'http://isla.rogiroaceros.com:9980/cgi-bin/wspd_cgi.sh/WService=rogiro/pedidos-pendientes.r';
  cotizacionesEndpoint = 'http://isla.rogiroaceros.com:9980/cgi-bin/wspd_cgi.sh/WService=rogiro/cotizaciones.r';

  constructor(private http: HttpClient) { }

  activities(c: number, s, f) {
    let endpoint = this.activitiesEndpoint;
    let params = 'cliente=' + c + '&fechaDesde=' + s + '&fechaHasta=' + f;
    return this.http.post(endpoint, params);
  }

  balance(code: number) {
    let endpoint = this.balanceEndpoint;
    let params = 'cliente=' + code;
    return this.http.post(endpoint, params);
  }

  pending() {
    let endpoint = this.pendingEndpoint;
    return this.http.get(endpoint);
  }

  changePassword(password: string) {
    let endpoint = this.changePasswordEndpoint;
    let params = 'newPassword=' + password;
    return this.http.post(endpoint, params);
  }

  price() {
    let endpoint = this.cotizacionesEndpoint;
    return this.http.get(endpoint);
  }

  getItems(item: any) {
    let endpoint = this.getItemEndpoint;
    let params = 'term=' + item
    return this.http.post(endpoint, params);
  }
  
}
